/**
 * @module Core
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 * @preferred
 *
 * The Core Module is responsible for proving the application all the necessary services and dependencies on the
 * immediate run time.
 */ /** */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderModule } from '@core/loader/loader.module';
import { ErrorHandlerModule } from '@core/error-handler/error-handler.module';
import { AppStateService } from '@core/services/app-state.service';
import { WorkerModule } from '@core/worker/worker.module';
import { AemModule } from '@core/aem/aem.module';
import { MatchmediaService } from '@core/services/matchmedia.service';
import { ApiGatewayService } from '@core/api/services/api-gateway-service';
import { ContentProviderService } from '@core/aem/services/content-provider.service'; // @TODO remove
import { HttpEventInterceptorService } from '@core/error-handler/services/http-event-interceptor.service';
import { AppConfig } from '@root/app.config';
import { LoggerModule } from '@core/logger/logger.module';
import { AspectsModule } from '@core/aspects/aspects.module';
import { SeoService } from '@core/services/seo.service';
import { FeatureToggleModule } from '@core/feature-toggle/feature-toggle.module';
import { PdlWrapperService } from '@core/services/pdl-wrapper.service';

@NgModule({
  imports: [
    CommonModule,
    LoaderModule,
    ErrorHandlerModule,
    AemModule,
    FeatureToggleModule,
    WorkerModule,
    LoggerModule,
    AspectsModule,
  ],
  providers: [
    AppStateService,
    HttpEventInterceptorService,
    MatchmediaService,
    ApiGatewayService,
    ContentProviderService,
    AppConfig,
    SeoService,
    PdlWrapperService,
  ],
  exports: [],
})
export class CoreModule {}
